<template>
  <div class="recording-preview">
    <a class="label" :href="downloadLink" target="_blank" v-if="finished">
      <span v-tooltip.right="'Download'">
        Recording
        <fa-icon icon="cloud-download-alt" />
      </span>
    </a>
    <div class="label" v-else>
      Recording
    </div>
    <div class="centered-label" v-if="!finished">
      <div class="label" v-if="initializing || processing">Processing</div>
      <div class="label" v-if="noRecording">No video</div>
    </div>
    <div class="recording-preview-video" v-if="finished">
      <loading-logo v-if="isLoading" :autoplay="true"/>
      <video v-if="videoUrl" :src="videoUrl" controls preload>
      </video>
    </div>
  </div>
</template>

<script>
  import Spinner from "../ui/Spinner";
  import {getCompositionUrl} from "../../services/apollo/sessions";
  import LoadingLogo from "../LoadingLogo";
  import {mapState} from 'vuex';

  export default {
    name: 'RecordingPreview',
    components: {LoadingLogo, Spinner},
    props: {
      sessionLog: {
        type: Object
      }
    },

    data: () => ({
      isLoading: true,
      videoUrl: null
    }),

    computed: {
      ...mapState({
        authToken: state => state.auth.token
      }),
      initializing() {
        return this.sessionLog.hasRecording !== null && this.sessionLog.hasRecording !== undefined
      },
      processing() {
        return this.sessionLog.hasRecording !== null && this.sessionLog.hasRecording !== undefined
      },
      finished() {
        return (this.sessionLog.compositionSid
          && this.sessionLog.hasRecording) || this.sessionLog.compositionUrl
      },
      noRecording() {
        return !this.initializing && !this.processing
      },

      downloadLink() {
        let apiUrl = process.env.VUE_APP_API_URL || 'https://arstream.vitech.dev';
        return this.sessionLog.compositionUrl || `${apiUrl}/composition/download/${this.sessionLog.compositionSid}?token=${this.authToken}`
      },

    },

    methods: {
      close() {
        this.$emit('close')
      },

      closeOnEscape(e) {
        if (e.which === 27) {
          this.close()
        }
      },

      initializeVideo() {
        if(this.sessionLog.compositionUrl) {
          this.isLoading = false;
          this.videoUrl = this.sessionLog.compositionUrl
        } else {
          getCompositionUrl(this.sessionLog.compositionSid)
            .then(res => {
              this.isLoading = false;
              this.videoUrl = res.redirect_to;
            });
        }
      }
    },

    mounted() {
      if (this.finished) {
        this.initializeVideo()
      }
    },

    watch: {
      finished() {
        this.initializeVideo()
      }
    }
  }
</script>

<style lang="scss">
  @import "RecordingPreview";
</style>
